export const ITEM_PROPERTIES = Object.freeze({
	IS_SELECTED: "isSelected",
	IS_ACTIVE: "isActive",
});
